import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import SubscriptionPeriodsModule from './subscription-periods/index'

export default {
  namespaced: true,
  state: {
    all: [],
    single: null,
    metaDataColumns: null,
    batchEmails: null
  },
  actions,
  getters,
  mutations,
  modules: {
    subscriptionPeriods: {
      ...SubscriptionPeriodsModule
    }
  }
}
